/* ==========================================================================
   Design System
   Variables
   ========================================================================== */
/* ==========================================================================
   Design System
   Breakpoint variables.

   NOTE: If any of the values in this file are adjusted,
         they need to be adjusted in vars-breakpoints.js as well.
   ========================================================================== */
/* ==========================================================================
   Design System
   Grid mixins
   ========================================================================== */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* stylelint-disable selector-class-pattern */
/* ==========================================================================
   Design System
   Media queries
   ========================================================================== */
/* ==========================================================================
   Design System
   Base styles
   ========================================================================== */
/* ==========================================================================
   Design System
   Button Styling
   ========================================================================== */
.a-btn--link {
  padding: 0;
  padding-bottom: 1.5px;
  border-radius: 0;
  text-decoration-line: underline;
  text-decoration-thickness: 1px;
  text-decoration-style: dotted;
  text-underline-offset: 4.5px;
}
.a-btn--link, .a-btn--link:link, .a-btn--link:visited {
  text-decoration-color: var(--pacific);
  background-color: transparent;
  color: var(--pacific);
}
.a-btn--link:hover, .a-btn--link.hover {
  text-decoration-color: var(--pacific-dark);
  text-decoration-style: solid;
  background-color: transparent;
  color: var(--pacific-dark);
}
.a-btn--link:focus, .a-btn--link.focus {
  text-decoration-style: solid;
  background-color: transparent;
  outline: 1px dotted var(--pacific);
}
.a-btn--link:active, .a-btn--link.active {
  text-decoration-color: var(--navy);
  text-decoration-style: solid;
  background-color: transparent;
  color: var(--navy);
}
.a-btn--link.a-btn--secondary, .a-btn--link.a-btn--secondary:link, .a-btn--link.a-btn--secondary:visited {
  text-decoration-color: var(--gray);
  background-color: transparent;
  color: var(--gray);
}
.a-btn--link.a-btn--secondary:hover, .a-btn--link.a-btn--secondary.hover {
  text-decoration-color: var(--gray-dark);
  color: var(--gray-dark);
}
.a-btn--link.a-btn--secondary:focus, .a-btn--link.a-btn--secondary.focus {
  outline-color: var(--gray);
}
.a-btn--link.a-btn--secondary:active, .a-btn--link.a-btn--secondary.active {
  text-decoration-color: var(--black);
  color: var(--black);
}
.a-btn--link.a-btn--warning, .a-btn--link.a-btn--warning:link, .a-btn--link.a-btn--warning:visited {
  text-decoration-color: var(--red-mid-dark);
  background-color: transparent;
  color: var(--red-mid-dark);
}
.a-btn--link.a-btn--warning:hover, .a-btn--link.a-btn--warning.hover {
  text-decoration-color: var(--red-dark);
  color: var(--red-dark);
}
.a-btn--link.a-btn--warning:focus, .a-btn--link.a-btn--warning.focus {
  outline-color: var(--red-mid-dark);
}
.a-btn--link.a-btn--warning:active, .a-btn--link.a-btn--warning.active {
  text-decoration-color: var(--gray-dark);
  color: var(--gray-dark);
}